let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bzrMt")).then(() => parcelRequire('4Ov3V'));